<template>
    <div>
        <el-drawer :visible.sync="visible" title="工单详情" size="45%" direction="rtl" :before-close="handleClose">
            <!-- 外层flex纵向布局，高度100%实现上下固定中间滚动 -->
            <div v-if="ticketInfo" class="ticket-wrap">
                <!-- 顶部：工单基础信息卡片 固定不滚动 -->
                <div class="top-card">
                    <el-card class="info-card">
                        <div class="info-left-line"></div>
                        <div class="status-tag">
                            <el-button v-if="canReply" type="success" size="small"
                                @click="updateTicketStatus">完结工单</el-button>
                        </div>
                        <div class="info-text-group">
                            <p>处理状态：<el-tag :type="statusTagType" size="small">{{ statusName }}</el-tag></p>
                            <p>创建时间：{{ ticketInfo.created_at }}</p>
                            <p>观星树账号：{{ ticketInfo.user_mobile }}</p>
                            <p v-if="ticketInfo.ticket_sn">工单号：{{ ticketInfo.ticket_sn }}</p>
                            <p>工单标题：{{ ticketInfo.title }}</p>
                            <p v-if="ticketInfo.effect_no">问题单号：{{ ticketInfo.effect_no }}</p>
                            <p v-if="ticketInfo.finish_time">完结时间：{{ ticketInfo.finish_time }}</p>
                        </div>
                    </el-card>
                </div>

                <!-- 中间：沟通记录 自适应高度、单独滚动 -->
                <div class="middle-chat">
                    <div class="chat-title">沟通记录</div>
                    <div class="chat-list">
                        <div v-for="msg in msgList" :key="msg.id" class="chat-item">
                            <!-- 左侧头像固定在左，不分用户/客服左右翻转 -->
                            <div class="chat-avatar">
                                <i v-if="msg.sender_type === 1" class="el-icon-user-solid"></i>
                                <i v-else class="el-icon-service"></i>
                            </div>
                            <!-- 右侧整块内容容器 -->
                            <div class="chat-content-wrap">
                                <!-- 头部：名称 + 时间 -->
                                <div class="chat-name-row">
                                    <span class="chat-name">{{ msg.sender_type == 1 ? '用户' : '观星树' }}</span>
                                    <span class="chat-time">{{ msg.created_at }}</span>
                                </div>

                                <!-- 主体内容，如果是用户首条消息会拆分多行标签信息 -->
                                <div class="chat-text-block">
                                    <div class="text-line">
                                        <span class="label">工单描述：</span>
                                        <span class="value">{{ msg.content }}</span>
                                    </div>
                                    <!-- <div v-if="msg.attachments" class="text-line">
                                        <span class="label">图片：</span>
                                        <span class="value">
                                            <el-image v-for="attachment in msg.attachments" :key="attachment.url"
                                                :src="attachment.url" width="80" preview />
                                        </span>
                                    </div> -->
                                    <div v-if="msg.attachments && msg.attachments.length" class="text-line">
                                        <span class="label">图片/附件：</span>
                                        <span class="value attachment-box">
                                            <div v-for="(attachment, index) in msg.attachments"
                                                :key="attachment.url + '_' + index" class="attachment-wrap">
                                                <!-- 图片 -->
                                                <div v-if="isImage(attachment.object_name)" class="img-item">
                                                    <el-image :src="attachment.url"
                                                        @click="openImgPreview(getImageUrls(msg.attachments), index)"
                                                        preview fit="cover" />
                                                </div>
                                                <!-- 文件 -->
                                                <div v-else class="file-item" @click="handleOpen(attachment)">
                                                    <i class="el-icon-document"></i>
                                                    <span>{{ attachment.object_name }}</span>
                                                </div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="canReply" class="bottom-reply">
                    <!-- 第一行：头像 + 文本输入框同行 -->
                    <div class="reply-top-row">
                        <div class="reply-avatar">
                            <i class="el-icon-user-solid"></i>
                        </div>
                        <div class="textarea-wrap">
                            <el-input size="small" v-model="form.replyContent" type="textarea" :rows="3"
                                placeholder="请输入回复" maxlength="300" show-word-limit></el-input>
                        </div>
                    </div>
                    <div class="reply-top-row">
                        <div class="reply-coll">
                        </div>
                        <!-- 第二块：附件上传区域 -->
                        <div class="upload-box">
                            <el-upload class="img-upload-card" ref="attachments"
                                list-type="picture-card" :http-request="uploadAttachment" :on-success="handleUploadSuccess"
                                :on-change="handleUploadChange" :limit="5" :file-list="fileList"
                                :on-preview="handleOpen" :on-remove="handleUploadRemove" :before-upload="beforeUpload"
                                :disabled="batchUploading">
                                <div class="upload-inner">
                                    <i class="el-icon-plus upload-icon"></i>
                                    <div class="upload-num">({{ form.attachments.length || 0 }}/5)</div>
                                </div>
                            </el-upload>
                        </div>
                    </div>
                    <div class="reply-top-row">
                        <div class="reply-coll">
                        </div>
                        <div>
                            <el-button size="mini" type="primary" @click="sendMsg"
                                :disabled="form.replyContent.length === 0" :loading="sendLoading">
                                提交回复
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
        <!-- 弹窗：新增/修改/查看 通用 -->
        <el-image ref="globalImg" style="display: none;" :src="currentPreviewUrl"
            :preview-src-list="currentPreviewUrlList"></el-image>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { createDirectUploadRequest } from "@/assets/js/utils/ossDirectUpload";
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        ticketId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            ticketInfo: null,
            sendLoading: false,
            msgList: [],
            statusMap: {
                1: { name: '待处理', type: 'warning' },
                2: { name: '处理中', type: 'primary' },
                3: { name: '待确认', type: 'success' },
                4: { name: '已完成', type: 'info' },
            },
            batchUploading: false,
            fileList: [],
            currentPreviewUrl: '',
            currentPreviewUrlList: [],
            form: {
                ticketId: '',
                attachments: [],
                replyContent: '',
            }
        }
    },
    computed: {
        statusName() {
            return this.ticketInfo?.status ? this.statusMap[this.ticketInfo.status].name : ''
        },
        statusTagType() {
            return this.ticketInfo?.status ? this.statusMap[this.ticketInfo.status].type : ''
        },
        canReply() {
            if (!this.ticketInfo) return false
            return [1, 2, 3].includes(this.ticketInfo.status)
        },
    },
    watch: {
        visible(val) {
            if (val && this.ticketId > 0) {
                this.loadMsgList()
                this.form.replyContent = ''
                this.form.attachments = []
            } else {
                this.ticketInfo = null
                this.msgList = []
            }
        },
        ticketId(val) {
            if (this.visible && val > 0) {
                this.loadMsgList()
            }
        }
    },
    methods: {
        ...mapActions({
            opGetTicketInfo: 'ucenter/opGetTicketInfo',
            opUpdateTicketStatus: 'ucenter/opUpdateTicketStatus',
            opSaveUserTicketMsg: 'ucenter/opSaveUserTicketMsg',
        }),
        loadMsgList() {
            this.loading = true
            this.ticketInfo = {}
            this.msgList = []
            this.form.ticketId = ''
            this.form.attachments = []
            this.form.replyContent = ''
            const uploadRef = this.$refs['attachments'];
            // 先判断实例存在再调用方法，杜绝报错
            if (uploadRef && uploadRef.clearFiles) {
                uploadRef.clearFiles();
            }
            this.opGetTicketInfo({
                data: { 'ticketId': this.ticketId },
                success: (res) => {
                    this.loading = false
                    if (res.code == 200) {
                        this.ticketInfo = res.data
                        this.msgList = res.data.ticketmsg
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        sendMsg() {
            this.sendLoading = true
            this.form.ticketId = this.ticketId
            this.opSaveUserTicketMsg({
                data: this.form,
                success: (res) => {
                    this.sendLoading = false
                    if (res.code == 200) {
                        this.loadMsgList()
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        handleClose() {
            this.$emit('update:visible', false)
        },
        beforeUpload(file) {
            // 限制格式示例，按需开启
            const allowType = [// 图片
                'image/jpeg',
                'image/jpg',
                'image/png',
                // PDF
                'application/pdf',
                // Word
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword',
                // Excel
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel',
                // TXT 文本
                'text/plain'];
            if (!allowType.includes(file.type)) {
                this.$message.error('仅支持 jpg、png、pdf、word、excel、txt 格式');
                return false;
            }

            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isLt5M) {
                this.$message.error('文件大小不能超过 5MB！');
                return false;
            }
            return true;
        },
        handleUploadSuccess(res, file) {
            if (res.code == 200) {
                const url = res?.data?.url ?? '';
                if (url == '') {
                    this.$message.error('文件上传失败')
                }
                this.form.attachments = this.form.attachments || []
                const hasExist = this.form.attachments.some(item => item.url === url);
                if (!hasExist) {
                    let fileinfo = { url: res?.data?.url ?? '', object_name: res?.data?.object_name ?? '', suffix: res?.data?.suffix ?? '', storage_path: res?.data?.storage_path ?? '' }
                    this.form.attachments.push(fileinfo);
                } else {
                    this.$message.error('文件已上传过，请上传其他图片')
                }
            } else {
                this.$message.error('文件上传失败')
            }
            this.batchUploading = false;

        },
        uploadAttachment(options) {
            createDirectUploadRequest(options, { purpose: 'attachment' });
        },
        handleUploadRemove(file, fileList) {
            // 1. 从上传文件列表中移除当前文件（页面立刻消失）
            const idx = fileList.findIndex(f => f.uid === file.uid)
            if (idx > -1) {
                fileList.splice(idx, 1)
            }
            // 先收集当前页面所有有效 url
            const existUrls = fileList.map(item => item.url).filter(Boolean);

            // 过滤：只保留 url 还在 existUrls 里的对象
            this.form.attachments = this.form.attachments.filter(item => {
                return item && item.url && existUrls.includes(item.url);
            });
        },
        // 批量上传开始
        handleUploadChange(file) {
            if (file.status === 'ready') {
                this.batchUploading = true
            }
        },
        // 判断是否为图片
        isImage(url) {
            if (!url) return false
            const ext = url.split('.').pop().toLowerCase()
            return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)
        },

        // 点击文件名
        handleOpen(item) {
            const { url, name } = item
            if (!url) return

            if (this.isImage(url)) {
                this.currentPreviewUrl = ''
                this.currentPreviewUrlList = []
                this.$nextTick(() => {
                    this.currentPreviewUrl = url
                    this.currentPreviewUrlList.push(this.currentPreviewUrl)
                    this.$nextTick(() => {
                        const img = this.$refs.globalImg
                        if (img && img.clickHandler) {
                            img.clickHandler()
                        }
                    })
                })
            } else {
                // 非图片：下载文件
                const a = document.createElement('a')
                a.href = url
                a.download = name
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }
        },
        getImageUrls(list) {
            const arr = Array.isArray(list) ? list : []
            return arr.filter(item => this.isImage(item?.url)).map(item => item.url)
        },

        // 打开图片预览（支持多张，从当前点击索引开始）
        openImgPreview(imgList, startIndex) {
            this.currentPreviewUrl = imgList[startIndex]
            this.currentPreviewUrlList = imgList
            this.$nextTick(() => {
                // 触发 el-image 预览
                this.$refs.globalImg?.clickHandler?.()
            })
        },
        updateTicketStatus() {
            this.$confirm('确定要完结该工单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true
                this.opUpdateTicketStatus({
                    data: { 'ticketId': this.ticketId, 'status': 4 },
                    success: (res) => {
                        this.loading = false
                        if (res.code == 200) {
                            this.$emit('update:visible', false)
                            this.$message.success('工单完结')
                            // 可选：通知父页面刷新列表
                            this.$emit('refresh-table')
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })
            }).catch(() => {
                // 取消操作，不执行任何逻辑
            })
        },
    }
}
</script>

<style scoped>
/* 抽屉内外层：纵向弹性布局，占满抽屉高度 */
.ticket-wrap {
    width: 100%;
    height: 100%;
    padding: 0 5%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;
}



/* 中间聊天区域：自适应填满剩余空间，内部滚动 */
.middle-chat {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* 底部回复区域：固定不压缩 */
.bottom-reply {
    flex-shrink: 0;
    padding-top: 10px;
    padding-bottom: 6px;
    /* border-top: 1px solid #eeeeee; */
}

/* 缩小上传图片卡片间距 */
/deep/ .bottom-reply .el-upload--picture-card {
    margin: 6px 0;
}

/* 顶部卡片区域：固定高度不压缩 */
.info-card {
    position: relative;
    /* 父容器相对定位，子元素才能悬浮在右上角 */
    padding-left: 14px !important;
}

.info-left-line {
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 100%;
    background-color: #67c23a;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

/* 右上角悬浮标签 */
.status-tag {
    position: absolute;
    top: 22px;
    right: 25px;
    z-index: 2;
}

.info-text-group p {
    color: #727483;
    font-size: 12px;
    line-height: 18px;
    padding-top: 3px;
}

/* 沟通标题 */
.chat-title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
    flex-shrink: 0;
}

/* 聊天列表单独滚动 */
.chat-list {
    flex: 1;
    overflow-y: auto;
    padding: 10px;
    background: #fff;
    border-radius: 6px;
}

/* 单条消息布局 */
.chat-item {
    display: flex;
    gap: 10px;
    margin-bottom: 18px;
    align-items: flex-start;
}

.chat-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #e6e6e6;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #666;
}

.chat-content-wrap {
    flex: 1;
}

.chat-name-row {
    justify-content: space-between;
    margin-bottom: 6px;
}

.chat-name {
    font-size: 14px;
    font-weight: 500;
    color: #292b33;
}

.chat-time {
    font-size: 12px;
    color: #aeadb9;
    padding-left: 8px;
}

.chat-text-block {
    font-size: 14px;
    line-height: 20px;
    color: #55585c;
}

.text-line {
    display: flex;
    margin: 4px 0;
    line-height: 1.5;
}

.label {
    font-size: 14px;
    color: rgb(103, 106, 120);
    margin-right: 8px;
}

.value {
    flex: 1;
    font-size: 14px;
    color: #292b33;
}

/* 抽屉标题下方横线 */
/deep/ .el-drawer__header {
    border-bottom: 1px solid #eee;
    padding-bottom: 12px !important;
    margin-bottom: 16px;
}

.attachment-box {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    align-items: center;
}

/* 外层容器固定30*30，约束图片大小 */
.img-item {
    width: 60px;
    height: 40px;
    border-radius: 2px;
    overflow: hidden;
}

/* 内部图片填满容器 */
/deep/ .img-item .el-image__inner {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.file-item {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    background: #f5f7fa;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    color: #409eff;
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-item:hover {
    background: #e6f7ff;
}

.attachment-wrap {
    flex-shrink: 0;
}

.bottom-reply {
    flex-shrink: 0;
    padding-top: 10px;
    padding-bottom: 6px;
    border-top: 1px solid #eeeeee;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* 头像+输入框一行布局 */
.reply-top-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

/* 左侧客服头像 */
.reply-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #e6e6e6;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #666;
}

.reply-coll {
    width: 40px;
    height: 40px;
    display: flex;
}

/* 文本框外层占满剩余宽度 */
.textarea-wrap {
    flex: 1;
    box-sizing: border-box;
}

/* 统一textarea边框、圆角、内边距 */
/deep/ .textarea-wrap .el-textarea__inner {
    border: 1px solid #dcdcdc;
    border-radius: 4px;
    font-size: 13px;
    padding: 8px 10px;
    box-sizing: border-box;
}

/* 聚焦蓝色边框统一风格 */
/deep/ .textarea-wrap .el-textarea__inner:focus {
    border-color: #409eff;
}

/* 上传外层容器：和textarea宽度、边框、圆角完全统一 */
.upload-box {
    width: 100%;
    border: 1px solid #dcdcdc;
    border-radius: 4px;
    padding: 10px;
    box-sizing: border-box;
}

/* 外层容器改为弹性横向布局 */
/deep/ .img-upload-card {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 10px;
}

/* 上传列表ul取消独占一行，取消默认边距 */
/deep/ .img-upload-card .el-upload-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 0 !important;
    padding: 0;
}

/* 每个图片li固定尺寸，不挤压 */
/deep/ .img-upload-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    flex-shrink: 0;
    margin: 0 !important;
}

/* 上传虚线加号卡片 */
/deep/ .img-upload-card .el-upload--picture-card {
    width: 80px;
    height: 80px;
    border: 1px dashed #d0d0d0;
    background: #fff;
    padding: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin: 0;
}

/deep/ .img-upload-card .el-upload--picture-card:hover {
    border-color: #409eff;
}

/* 上传内部加号文字完美居中 */
.upload-inner {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #999;
    box-sizing: border-box;
}

.upload-icon {
    font-size: 24px;
    margin: 0 0 4px 0;
    line-height: 1;
}

.upload-num {
    font-size: 12px;
    line-height: 1;
}
</style>
